<template>
	<h1 class="header">{{header}}</h1>
</template>

<script>
export default {
	props: {
		header: String
	}
}
</script>

<style lang="scss" scoped>
.header {
	@include fontH0;
	width: 100%;


	&::v-deep * {
		@include fontLeadIn;
	}

	@include mq($from: m) {
		@include gridColumn(m, 15, 1, false, true);
	}

	@include mq($from: xl) {
		@include gridColumn(xl, 13, 2, false, true);
	}
}

</style>